import { useCallback } from 'react';
import { useCombinedDocumentsListV3 } from '@frontend/documents-hooks';
import { useContentComposer } from '../../content-composer/content-composer-provider';

export const useDocuments = () => {
  const { locationIds } = useContentComposer();
  const documents = useCombinedDocumentsListV3(locationIds);

  const getDocument = useCallback(
    (documentId: string) => {
      if (!documents) return undefined;
      return documents.find((form) => form.id === documentId);
    },
    [documents]
  );

  return { getDocument };
};
